/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { MouseEvent } from "react";
import { PhotoWithIndex } from "type";
import { ImageItem } from "component/image";
import { VideoItem } from "component/video";

type Props = {
    photos: PhotoWithIndex[];
    onPhotoClick: (event: MouseEvent<HTMLImageElement>, index: number) => void;
    onVideoClick: (event: MouseEvent<HTMLDivElement>, index: number) => void;
};

export const MediaGrid = ({ photos, onPhotoClick, onVideoClick }: Props) => {
    return (
        <ul css={gridContainerCss}>
            {photos.map((v, idx) => {
                const element =
                    v.type === "video" ? (
                        <VideoItem photo={v} onClick={onVideoClick} />
                    ) : (
                        <ImageItem photo={v} onClick={onPhotoClick} />
                    );
                return (
                    <li css={liCss} key={v.filename}>
                        {element}
                    </li>
                );
            })}
        </ul>
    );
};

const gridContainerCss = css`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 3px;
  margin: 0;
  padding: 0;
`;

const liCss = css`
  aspect-ratio: 1;
  position: relative;
  list-style-type: none;
  margin: 0;
  padding: 0;
`;
